<template>
    <div class="dialog">
        <v-dialog
            v-model="show"
            max-width="80vw"
            persistent
            :retain-focus="false"
            eager
            scrollable
        >
            <v-card>
                <CardTitle
                    :type="type"
                />
                <v-card-text>
                    <v-container>
                        <v-form
                            ref="form"
                            v-model="valid"
                        >
                            <v-row>
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.session.zhTw"
                                        label="*屆數"
                                        placeholder="請輸入數字"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                        :rules="[v => /(?=.*[0-9])/.test(v) || '需輸入數字']"
                                    />
                                </v-col>
                                <v-col
                                    v-if="showType"
                                    cols="6"
                                >
                                    <v-select
                                        v-model="editData.type"
                                        :items="typeOptions"
                                        label="*類型"
                                        item-text="label"
                                        item-value="value"
                                        outlined
                                        clearable
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.fb"
                                        label="fb"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.youtube"
                                        label="youtube"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.ig"
                                        label="ig"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.mail"
                                        label="mail"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <div class="title-box">
                                <span class="title">中文版本</span>
                            </div>
                            <v-row
                                class="text-box"
                            >
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.title.zhTw"
                                        label="*提案名稱"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.name.zhTw"
                                        label="*團隊名稱"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    v-if="showType"
                                    cols="6"
                                >
                                    <v-textarea
                                        v-model="editData.selfTheme.zhTw"
                                        label="*自選主題"
                                        outlined
                                        clearable
                                        no-resize
                                        rows="10"
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-textarea
                                        v-model="editData.shareTheme.zhTw"
                                        label="*共同主題"
                                        outlined
                                        clearable
                                        no-resize
                                        rows="10"
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-textarea
                                        v-model="editData.content.zhTw"
                                        label="*計畫書內容"
                                        outlined
                                        clearable
                                        no-resize
                                        rows="10"
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-input
                                        class="file-box"
                                    >
                                        <v-file-input
                                            v-model="fileImg_zhTw"
                                            prepend-icon="mdi-camera"
                                            accept="image/png, image/jpeg"
                                            outlined
                                            class="file-input"
                                            :rules="[v => v.length===1 || '圖片不能為空']"
                                            @change="(value) => selectFile(value,'zhTw')"
                                        />
                                        <div
                                            class="file-img"
                                        >
                                            <v-img
                                                :src="image(editData.image.zhTw)"
                                                height="280px"
                                                width="fit-content"
                                                loading="true"
                                                contain
                                                position="left"
                                                class="change-img"
                                            >
                                                <v-btn
                                                    v-if="showUploadImg_zhTw"
                                                    width="280px"
                                                    height="280px"
                                                >
                                                    <v-icon>mdi-upload</v-icon>
                                                    *上傳圖片(建議 W:280px H:280px)
                                                </v-btn>
                                            </v-img>
                                        </div>
                                        <div
                                            class="image-delete-btn"
                                        >
                                            <v-btn
                                                class="mx-2"
                                                fab
                                                dark
                                                small
                                                color="grey"
                                                @click="clear('zhTw')"
                                            >
                                                <v-icon dark>
                                                    mdi-close-thick
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </v-input>
                                </v-col>
                                <v-col
                                    v-if="showType"
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.rank.zhTw"
                                        label="排名"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <div class="title-box">
                                <span class="title">英文版本</span>
                            </div>
                            <v-row
                                class="text-box"
                            >
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.title.en"
                                        label="*提案名稱"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.name.en"
                                        label="*團隊名稱"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    v-if="showType"
                                    cols="6"
                                >
                                    <v-textarea
                                        v-model="editData.selfTheme.en"
                                        label="*自選主題"
                                        outlined
                                        clearable
                                        no-resize
                                        rows="10"
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-textarea
                                        v-model="editData.shareTheme.en"
                                        label="*共同主題"
                                        outlined
                                        clearable
                                        no-resize
                                        rows="10"
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-textarea
                                        v-model="editData.content.en"
                                        label="*計畫書內容"
                                        outlined
                                        clearable
                                        no-resize
                                        rows="10"
                                        :rules="[v => !!v || '此欄位為必填']"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-input
                                        class="file-box"
                                    >
                                        <v-file-input
                                            v-model="fileImg_en"
                                            prepend-icon="mdi-camera"
                                            accept="image/png, image/jpeg"
                                            outlined
                                            class="file-input"
                                            :rules="[v => v.length===1 || '圖片不能為空']"
                                            @change="(value) => selectFile(value,'en')"
                                        />
                                        <div
                                            class="file-img"
                                        >
                                            <v-img
                                                :src="image(editData.image.en)"
                                                height="280px"
                                                width="fit-content"
                                                loading="true"
                                                contain
                                                position="left"
                                                class="change-img"
                                            >
                                                <v-btn
                                                    v-if="showUploadImg_en"
                                                    width="280px"
                                                    height="280px"
                                                >
                                                    <v-icon>mdi-upload</v-icon>
                                                    *上傳圖片(建議 W:280px H:280px)
                                                </v-btn>
                                            </v-img>
                                        </div>
                                        <div
                                            class="image-delete-btn"
                                        >
                                            <v-btn
                                                class="mx-2"
                                                fab
                                                dark
                                                small
                                                color="grey"
                                                @click="clear('zhTw')"
                                            >
                                                <v-icon dark>
                                                    mdi-close-thick
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </v-input>
                                </v-col>
                                <v-col
                                    v-if="showType"
                                    cols="6"
                                >
                                    <v-text-field
                                        v-model="editData.rank.en"
                                        label="排名"
                                        outlined
                                        persistent-placeholder
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions
                    class="justify-end"
                >
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="closeEdit"
                    >
                        取消
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="submitEdit"
                    >
                        儲存
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CardTitle from '@/components/UI/CardTitle.vue';
import dialogMixin from '@/mixins/dialogMixin.vue';

export default {
    components: { CardTitle },
    mixins: [dialogMixin],
    props: {
        showType: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            showUploadImg_zhTw: true,
            showUploadImg_en: true,
            valid: false,
            editData: {
                type: '',
                fb: '',
                youtube: '',
                ig: '',
                mail: '',
                session: {
                    zhTw: '',
                    en: '',
                },
                rank: {
                    zhTw: '',
                    en: '',
                },
                image: {
                    zhTw: '',
                    en: '',
                },
                title: {
                    zhTw: '',
                    en: '',
                },
                name: {
                    zhTw: '',
                    en: '',
                },
                selfTheme: {
                    zhTw: '',
                    en: '',
                },
                shareTheme: {
                    zhTw: '',
                    en: '',
                },
                content: {
                    zhTw: '',
                    en: '',
                },
                images: [],
            },
            type: '',
            fileImg_zhTw: [],
            fileImg_en: [],
            typeOptions: [
                { label: '大專組', value: 'college' },
                { label: '高中職組', value: 'senior' },
            ],
        };
    },
    computed: {
    },
    created() {},
    mounted() {
    },
    methods: {
        editItem(data) {
            if (data) {
                this.type = '修改';
                this.editData = data;
                this.showUploadImg_zhTw = false;
                this.showUploadImg_en = false;
                this.fileImg_zhTw = [{}];
                this.fileImg_en = [{}];
            } else {
                this.type = '新增';
                this.editData = {
                    type: '',
                    fb: '',
                    youtube: '',
                    ig: '',
                    mail: '',
                    session: {
                        zhTw: '',
                        en: '',
                    },
                    rank: {
                        zhTw: '',
                        en: '',
                    },
                    image: {
                        zhTw: '',
                        en: '',
                    },
                    title: {
                        zhTw: '',
                        en: '',
                    },
                    name: {
                        zhTw: '',
                        en: '',
                    },
                    selfTheme: {
                        zhTw: '',
                        en: '',
                    },
                    shareTheme: {
                        zhTw: '',
                        en: '',
                    },
                    content: {
                        zhTw: '',
                        en: '',
                    },
                    images: [],
                };
            }
        },
        closeEdit() {
            this.show = false;
            this.$emit('search');
            this.fileImg_zhTw = [];
            this.fileImg_en = [];
        },
        selectFile(file, data) {
            if (file && (file.constructor === File || file.constructor === Blob)) {
                this.editData.image[`${data}`] = window.URL.createObjectURL(file);
                this[`fileImg_${data}`] = [{}];
                this[`showUploadImg_${data}`] = false;
            }
        },
        clear(data) {
            this.editData.image[`${data}`] = '';
            this[`fileImg_${data}`] = [];
            this[`showUploadImg_${data}`] = true;
        },
        submitEdit() {
            const imageBaseUrl = `https://${process.env.VUE_APP_BASE_URL}`;
            this.editData.images = [
                ...this.editData.content.en.match(/img src="(.*?)"/g) || [],
                ...this.editData.content.zhTw.match(/img src="(.*?)"/g) || [],
            ].map((row) => row.replace(/img src="/, '').replace(/"$/, '').replace(imageBaseUrl, ''));
            this.editData.content.en = this.editData.content.en.replace(/blob:http/g, `${imageBaseUrl}blob:http`);
            this.editData.content.zhTw = this.editData.content.zhTw.replace(/blob:http/g, `${imageBaseUrl}blob:http`);
            //
            if (this.$refs.form.validate()) {
                this.$emit('saveData', this.editData);
                this.show = false;
            }
        },
    },
};
</script>

<style lang="scss">
</style>
